import * as yup from 'yup'

export const validationSchema = (t) =>
  yup.object().shape({
    shopId: yup.string().required(t('rewards.list.error.shop')),
    bannerImageId: yup.string().required(t('rewards.list.error.bannerImage')),

    shortDesc: yup.string().required(t('rewards.list.error.shortDesc50')),
    desc: yup.string().required(t('rewards.list.error.desc')),

    pointUsage: yup
      .number()
      .typeError(t('rewards.listOperation.isNumber'))
      .required(t('rewards.list.error.pointUsage')),
    totalAmount: yup
      .number()
      .typeError(t('rewards.listOperation.isNumber'))
      .required(t('rewards.list.error.totalAmount')),
    usablePerBill: yup
      .number()
      .typeError(t('rewards.listOperation.isNumber'))
      .required(t('rewards.list.error.usablePerBill')),
  })
